export const isFirstElement = (index) => index === 0;

export const capitalizeFirstLetter = (word) => word.charAt(0).toUpperCase() + word.slice(1);
